import { graphql } from "gatsby";
import React, { FC } from "react";

import { ImageSlider } from "./image-slider";
import { ZipTextBoxSlider } from "./zip-text-box-slider";

export interface BannerZipProps extends Queries.BannerZipDataFragment {}

export const BannerZip: FC<BannerZipProps> = ({ slides }) => {
  return !slides ? null : (
    <>
      <div className="relative block lg:hidden">
        <ImageSlider
          className="relative"
          images={slides.map((item) => item?.image?.gatsbyImageData!)}
        />
        <ZipTextBoxSlider
          className="absolute z-20 w-full right-0 top-0"
          labels={slides.map((item) => ({
            title: item?.title,
            caption: item?.caption,
          }))}
          mobile
        />
      </div>
      <div className="relative hidden lg:block">
        <ImageSlider
          className="relative"
          images={slides.map((item) => item?.image?.gatsbyImageData!)}
        />
        <ZipTextBoxSlider
          className="absolute z-20 w-full right-0 top-0"
          labels={slides.map((item) => ({
            title: item?.title,
            caption: item?.caption,
          }))}
        />
      </div>
    </>
  );
};

export const query = graphql`
  fragment BannerZipData on ContentfulBannerZip {
    __typename
    slides {
      title
      caption
      image {
        gatsbyImageData
      }
    }
  }
`;
